interface Settings {
  master: number;
  music: number;
  sfx: number;
  shake: boolean;
  burst: number;
  godMode: boolean;
}

const KEY = 'ns_settings_pixi';

const DEFAULTS: Settings = {
  master: 0.3,
  music: 0.18,
  sfx: 1.0,
  shake: true,
  burst: 1.0,
  godMode: false,
};

export const settings: Settings = load();

function load(): Settings {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || '{}');
    return { ...DEFAULTS, ...raw };
  } catch {
    return { ...DEFAULTS };
  }
}

export function saveSettings(): void {
  localStorage.setItem(KEY, JSON.stringify(settings));
}

export function setMaster(v: number): void {
  settings.master = Math.max(0, Math.min(1, v));
  saveSettings();
}
export function setSfx(v: number): void {
  settings.sfx = Math.max(0, Math.min(1, v));
  saveSettings();
}
export function toggleShake(): void {
  settings.shake = !settings.shake;
  saveSettings();
}
export function toggleGodMode(): void {
  settings.godMode = !settings.godMode;
  saveSettings();
}
